// Toast utility - safe for server-side import
// Toast functions only execute on client side

// Success toast
export const showSuccess = (message) => {
  if (typeof window === 'undefined') return;
  
  // Dynamic import only when called on client
  import('react-hot-toast').then((toastModule) => {
    toastModule.default.success(message);
  }).catch(() => {
    // Silently fail if toast is not available
  });
};

// Error toast
export const showError = (message) => {
  if (typeof window === 'undefined') return;
  
  console.log('showError', message);
  
  // Dynamic import only when called on client
  import('react-hot-toast').then((toastModule) => {
    toastModule.default.error(message);
  }).catch(() => {
    // Silently fail if toast is not available
  });
};

// Info toast
export const showInfo = (message) => {
  if (typeof window === 'undefined') return;
  
  import('react-hot-toast').then((toastModule) => {
    toastModule.default(message, {
      icon: 'ℹ️',
    });
  }).catch(() => {});
};

// Warning toast
export const showWarning = (message) => {
  if (typeof window === 'undefined') return;
  
  import('react-hot-toast').then((toastModule) => {
    toastModule.default(message, {
      icon: '⚠️',
    });
  }).catch(() => {});
};

// Loading toast
export const showLoading = (message = 'Loading...') => {
  if (typeof window === 'undefined') return;
  
  return import('react-hot-toast').then((toastModule) => {
    return toastModule.default.loading(message);
  }).catch(() => {
    return null;
  });
};

// Promise toast (for async operations)
export const showPromise = (promise, messages) => {
  if (typeof window === 'undefined') return;
  
  return import('react-hot-toast').then((toastModule) => {
    return toastModule.default.promise(promise, messages);
  }).catch(() => {
    return null;
  });
};

// Custom toast
export const showCustom = (message, options = {}) => {
  if (typeof window === 'undefined') return;
  
  import('react-hot-toast').then((toastModule) => {
    toastModule.default(message, options);
  }).catch(() => {});
};

// Dismiss specific toast
export const dismissToast = (toastId) => {
  if (typeof window === 'undefined') return;
  
  import('react-hot-toast').then((toastModule) => {
    toastModule.default.dismiss(toastId);
  }).catch(() => {});
};

// Dismiss all toasts
export const dismissAll = () => {
  if (typeof window === 'undefined') return;
  
  import('react-hot-toast').then((toastModule) => {
    toastModule.default.dismiss();
  }).catch(() => {});
};
